export default __webpack_public_path__ + "static/media/8.d0ece114.jpeg";